import React from 'react';
import { cn } from '@/utils/cn';
import { LIST_VIEW } from '@/constants';
import { ribbonList } from '@/constants/list';
import { useSelector } from 'react-redux';
import Badge from '../../Badge';
import WishListButton from '../../Button/WishListButton';
import ProductCardImageSlider from '../../Slider/ProductCardImageSlider';

function ProductCardImage({ productData, viewType }) {
  const { lang } = useSelector((state) => state.globalSettings);

  return (
    <div
      className={cn('product-card-image-container rounded-[12px]', {
        'w-[160px] lg:min-w-[220px] relative': viewType === LIST_VIEW,
      })}
    >
      {ribbonList.includes(productData.ribbon?.icon) ? (
        <div
          className={cn('absolute top-0 left-0 z-10', {
            'top-[4px] lg:top-[8px] left-[4px] lg:left-[8px]':
              productData.ribbon?.icon === 'hot' ||
              productData.ribbon?.icon === 'placeholder',
          })}
        >
          <Badge
            type={productData?.ribbon.icon}
            size="sm"
            title={productData?.ribbon?.title?.en}
            imageSrc={productData?.ribbon?.placeholder || ''}
            gradientColorStart={productData?.ribbon?.gradient_color_start}
            gradientColorEnd={productData?.ribbon?.gradient_color_end}
          />
        </div>
      ) : null}
      <div
        className={cn(
          'absolute top-[3px] lg:top-[-6px] right-[4px] lg:right-[2px] z-10',
          {
            'right-0': viewType === LIST_VIEW,
          },
        )}
      >
        <WishListButton productData={productData} />
      </div>

      {/* top slider */}
      <div className="h-full">
        <ProductCardImageSlider
          viewType={viewType}
          name={productData?.name[lang] ?? ''}
          images={productData?.images?.wide ?? []}
          className={cn('max-w-full lg:max-w-full')}
          sliderType="v2"
        />
      </div>
    </div>
  );
}

export default ProductCardImage;
